import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

const useMenu = () => {
  const location = useLocation();
  const history = useHistory();
  const [usuario, setUsuario] = useState({});
  const [openModalPaciente, setOpenModalPaciente] = useState(false);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });

  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir === true) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const cerrarSesion = () => {
    try {
      // Mostrar notificación de cierre de sesión
      mostrarNotificacion(true, "Cerrando sesión...", "info");
      
      // Limpiar datos de sesión
      sessionStorage.removeItem("ppUL");
      localStorage.removeItem("ppUL");
      
      // Pequeña pausa para mostrar la notificación antes de redirigir
      setTimeout(() => {
        // Redirigir al login
        history.push("/login");
        // Opcional: recargar la página para limpiar completamente el estado
        window.location.reload();
      }, 1500);
      
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
      // En caso de error, forzar la redirección
      history.push("/login");
    }
  };

  useEffect(() => {
    try {
      setUsuario(JSON.parse(sessionStorage.getItem("ppUL")));
    } catch {
      history.push({ pathname: "/ErrorPage" });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Abrir el modal solo si la ruta es "/portal/Datos"
    if (location.pathname === "/portal/Datos") {
      setOpenModalPaciente(true);
    } else {
      setOpenModalPaciente(false);
    }
  }, [location.pathname]);

  return {
    location,
    usuario,
    setUsuario,
    openModalPaciente,
    setOpenModalPaciente,
    toast,
    setToast,
    mostrarNotificacion,
    cerrarSesion,
  };
};

export default useMenu;
